import Levels from './Levels';
import Services from './Services';
import Addons from './Addons';

const Headers = {
  LevelsHeader: Levels,
  ServicesHeader: Services,
  AddonsHeader: Addons,
};

export default Headers;
